import Icon from "../selfcare/Icon.tsx"
import {useCallback, useEffect, useState} from "react"
import CallMeFormComponent from "./CallMeFormComponent.tsx"
import Cookies from "js-cookie";
import {CallMeState, getCallMeOpeningHours} from "../../util/callMe.ts";
import IconCross from "../icons/IconCross.tsx";

const CallMeFloatingCookieName = 'exit-rmo-hide'

export default function CallMeFloatingComponent(props: {denyVisibility?: boolean}) {
    const [callMeState, setCallMeState] = useState<CallMeState>()
    const [visible, setVisible] = useState<boolean>(false)

    const setShow = useCallback(() => {
        if (visible) {
            return
        }

        getCallMeOpeningHours()
            .then((d) => setCallMeState(d))
            .then(() => setVisible(true))
            .catch(() => {})
    }, [visible])

    const setHide = () => {
        setVisible(false)
        Cookies.set(CallMeFloatingCookieName, '1', {expires: 30});
    }

    const hasDisabledPopup = () => {
        return Cookies.get(CallMeFloatingCookieName) === '1'
    }

    useEffect(() => {
        if (hasDisabledPopup() || props.denyVisibility) {
            return
        }

        window.addEventListener('blur', setShow)

        return () => window.removeEventListener('blur', setShow)
    }, [setShow, props.denyVisibility])

    useEffect(() => {
        if (hasDisabledPopup() || props.denyVisibility) {
            return
        }

        const timer = setTimeout(() => setShow(), 180 * 1000)
        return () => clearTimeout(timer)
    }, [setShow, props.denyVisibility])

    return (
        <div id="exit-rmo-container" className={`${visible ? 'exit-rmo-show' : 'exit-rmo-hide'}`}>
            <section className="call-me call-me-exit-rmo">
                <div className="content">
                    <button
                        className="close-float"
                        id="exit-rmo-container-hide-btn"
                        aria-label="Luk ring mig op dialogboks"
                        onClick={() => setHide()}
                    >
                        <Icon component={IconCross}/>
                    </button>
                    <div className="flex flex-column flex-center">
                        <h2>
                            Lad os ringe dig op med et godt <span className="hiper-text-stroke">tilbud</span>
                        </h2>
                    </div>
                    <CallMeFormComponent queue={"exit-rmo"}/>
                    {callMeState !== undefined && callMeState !== CallMeState.InboundAndOutboundClosed && (
                        <h3>Vi ringer inden for en time</h3>
                    )}
                </div>
            </section>
        </div>
    )
}
